import React from 'react';
import Skeleton from '../../common/skeleton';
import { Row, Col, Card } from 'react-bootstrap';

const ViewDocumentListSkeleton = () => (
  <>
    <Row className="mt-4">
      <Col>
        <Card className="p-3" sm={8}>
          <Skeleton count={10} height={40} />
        </Card>
      </Col>
    </Row>
  </>
);

export default ViewDocumentListSkeleton;
